import { useState, useEffect, useMemo, useCallback } from "react";
import { FieldValidation } from "common/functions";

export default function AdorElText({ ador, validate, updateAdorValue }) {

  const handleChange = (e) => {
    e.stopPropagation();
    // Auto format text before update using ador.format_text
    updateAdorValue(ador.ador_name, "user_value", e.target.value);
  }

  useEffect(() => {
    // Check required with ador.is_required
    if (ador.is_required) {
      FieldValidation([ador.ador_name]);
      updateAdorValue(ador.ador_name, "is_invalid", 1);
    }
    // Check format with ador.validation
  }, [validate]);

  return ador && ador.hidden == 0 && (
    <div className="row">
      <div className="col">
        <label className="form-label">{ador.label}</label>
        <input type="text" name={ador.ador_name}
          id={ador.ador_name}
          className="form-control"
          placeholder={ador.placeholder}
          value={ador.user_value}
          onChange={handleChange}
          readOnly={ador.readonly}
          required={ador.is_required}
        />
        <div className="invalid-feedback"></div>
      </div>
    </div>
  );
}
